import React from 'react';
export const ImdbIcon = ({
  size = 20,
  className = ''
}) => {
  return <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eKZpPqjadQUae4TFdb96QG/brand-imdb-icon-2048x828-pg6qoc0m.png" alt="IMDb" width={size * 2.5} height={size} className={`object-contain ${className}`} style={{
    filter: 'brightness(0) invert(1)'
  }} data-id="element-245" />;
};